import { call, put } from 'redux-saga/effects';
import GetTimeslotsThirtyDayActions from '../redux/GetTimeslotsThirtyDayRedux';
import { api } from './api';


export function* getTimeslotsThirtyDay(action: any): Generator<any, void, any> {
  const { leave_id, page, children_id, isTherapist } = action
  console.log('GetTimeslotsThirtyDaySagas: Calling API with:', { leave_id, page, children_id, isTherapist });
  
  const response = isTherapist ?  yield call(api.getTimeslotsThirtyDayTherapist, leave_id, children_id): yield call(api.getTimeslotsThirtyDay, leave_id, page || '1');

  if (response.ok) {
    console.log('GetTimeslotsThirtyDaySagas: API response success:', response.data);
    yield put(GetTimeslotsThirtyDayActions.getTimeslotsThirtyDaySuccess(response.data?.data))
  } else { 
    console.log('GetTimeslotsThirtyDaySagas: API response failed:', response);
    yield put(GetTimeslotsThirtyDayActions.getTimeslotsThirtyDayFailure())
  }
}